var choices = require('./exam_parts/choices');
var drawstars = require('./drawstars');
var checkProgress = require('./checkprogress');
var ajaxCalls = require('./ajaxCalls');


function QuestionController() {


    return {
        'setQuestion':function(exam,global,imageHost) {

            var answers = global.response.answers;
            var answer = answers[global.questionIndex];
            // console.log(answer);
            var question = answer.question;
            var questionIndex = global.questionIndex;

            // set title
            $(exam).find('.exam-title').html( questionIndex + 1 + '. ' +question.question);

            // set choices
            var q_choices = [ question.choice_1, question.choice_2];
            if ( typeof question.choice_3 != 'undefined' && question.choice_3 && question.choice_3.length > 0 ) {
                q_choices.push(question.choice_3);
            }
            if ( typeof question.choice_4 != 'undefined' && question.choice_4 && question.choice_4.length > 0) {
                q_choices.push(question.choice_4);
            }
            if ( typeof question.choice_5 != 'undefined' && question.choice_5 && question.choice_5.length > 0) {
                q_choices.push(question.choice_5);
            }
            $(exam).find('.choices-row .choices .list-group').html('');
            $(exam).find('.choices-row .choices .list-group').append(choices(q_choices,answer.answer));

            $(exam).find("input[name='answer[]']").click(function(){
                var answered = [];
                $("[name='answer[]']:checked").each(function() {
                    answered.push($(this).val());
                });
                answer.answer = answered;
                answer.status = 'seen';
                // progress bar. checked for unanswered
            });
            checkProgress(global);

            drawstars(exam,global);



            var imageFrame = $(exam).find('.image-frame');
            $(imageFrame).html('');
            var imageList = $(exam).find('.image-list');
            $(imageList).html('');

            var images = question.images;
            // set questionRight
            if ( images.length > 0 ) {
            // if (typeof question.image !== 'undefined') {
                var img = images[0];
                setImageFrame(img,imageFrame,imageHost);

                // image list
                
                _(images).forEach(function(mi) {
                    var smallImage = imageHost + mi.path + mi.name + '-small' + mi.ext;
                    var largeImage = imageHost + mi.path + mi.name + mi.ext;
                    var multiImageString = '<div class="col-lg-4 col-md-6"><img src="'+ smallImage + '" data="'+ largeImage +'"/></div>'
                    var mImage = $.parseHTML(multiImageString);
                    $(mImage).click(function() {
                        setImageFrame(mi,imageFrame,imageHost);
                    });
                    $(imageList).append(mImage);
                });


            }
            function setImageFrame(img,imageframe,imageHost) {
                var smallImage = imageHost + img.path + img.name + '-small' + img.ext;
                var largeImage = imageHost + img.path + img.name + img.ext;
                var image_string = '<span class="glyphicon glyphicon-search magnify"></span>' +
                '<img src="'+ smallImage  +'" data="'+ largeImage+ '"/>';
                var image = $.parseHTML(image_string);
                $(imageFrame).html('');
                $(imageFrame).append(image);
                $(imageFrame).find('.magnify').click(function() {
                    var modalDiv = $('#'+ global.modal);
                    $(modalDiv).on('hidden.bs.modal', function (e) {
                        $(modalDiv).find('.modal-content').html('');
                    });
                    var largeImage = $(imageFrame).find('img').attr('data');
                    var modalcontentstr = '<div class="modal-body magnify-image"><img src="'+ largeImage  +'" /></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div>';
                    var modalContent = $.parseHTML(modalcontentstr);
                    $(modalDiv).find('.modal-content').append(modalContent);
                    $(modalDiv).modal();

                });
            }

            // current-index
            $(exam).find('.current-index').html( (questionIndex +1)+ '/' + answers.length);



            // set the checkbox
            if (answer.guessed == 'yes') {
                $('#guessed').prop('checked','checked');
            } else {
                $('#guessed').prop('checked','');
            }

            if (global.questionIndex > 0 ) {
                enablePrevious();
            } else {
                disablePrevious();
            }
            if (global.questionIndex < answers.length -1 ) {
                enableNext();
            } else {
                disableNext();
            }

        },
        'halt': function(exam,global) {
            var modalDiv = $('#'+ global.modal);

            clearInterval(global.timer);
            // update the answer
            var answer = global.response.answers[global.questionIndex];
            ajaxCalls.scoreExam(global.userId,global.examId,answer);

            $(modalDiv).on('hidden.bs.modal', function (e) {
                document.location.href = sprintf(global.examReviewLink,{ examId:global.examId, userId:global.userId});
            });
            var modalcontentstr = '<div class="modal-body">Time has expired</div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Finish</button></div>';
            var modalContent = $.parseHTML(modalcontentstr);
            $(modalDiv).find('.modal-content').append(modalContent);
            $(modalDiv).modal();
        }
    }
}

module.exports = new QuestionController();


//////////////////
// WEBPACK FOOTER
// ./src/question_controller.js
// module id = 25
// module chunks = 0